import { toSecond } from '../../common/utilities';

// TagVideo's onProgress hands over to the next clip this many seconds before the
// tag's end_time. Anything the seek controls do has to respect that boundary.
export const CLIP_END_MARGIN = 3;

// ...and stop just short of it, so a forward seek lands inside the clip instead
// of immediately tripping the hand-over.
export const SEEK_STOP_MARGIN = 0.5;

// The playable window of a tag, in seconds of the underlying game video.
export function getClipWindow(tag) {
    if (!tag) return { start: 0, end: 0 };

    const start = toSecond(tag.start_time ?? tag.player_tag_start_time);
    const end = toSecond(tag.end_time ?? tag.player_tag_end_time) - CLIP_END_MARGIN;

    return { start, end: Math.max(start, end) };
}

// Hold a seek inside the clip. Without this a rewind past the start is snapped
// forward again by onProgress and a forward seek skips to the next clip, so both
// buttons read as broken.
export function clampToClip(seconds, { start, end }) {
    if (!Number.isFinite(seconds)) return start;

    return Math.min(Math.max(seconds, start), Math.max(start, end - SEEK_STOP_MARGIN));
}

export function clipLength({ start, end }) {
    return Math.max(0, end - start);
}

// Position within the clip as a 0-100 percentage, for the scrubber.
export function toClipFraction(seconds, window) {
    const length = clipLength(window);

    if (!length || !Number.isFinite(seconds)) return 0;

    return Math.min(100, Math.max(0, ((seconds - window.start) / length) * 100));
}

export function fromClipFraction(fraction, window) {
    return clampToClip(window.start + (fraction / 100) * clipLength(window), window);
}

export function formatClock(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) return '0:00';

    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);

    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
}
